/* eslint-disable*/
import React, { Component } from "react";
import Button from "./buttons/Button";
import styles from "../../assets/css/modules/shared/modal-popup-onboarding.css";
import { Layouts } from "../../constants/Constants";
import { getLayout } from "../../layout/Layout";
export class ModalPopupNeeds extends Component {
  constructor(props) {
    super(props);
    this.onBack = this.onBack.bind(this);
  }

  onBack(event) {
    this.props.setpreferenceConfirm('No'+'&'+this.props.communicationPrefid);
    event.preventDefault();
    this.props.cancel();
  }

  onChange() {    
    this.props.setpreferenceConfirm('Yes'+'&'+this.props.communicationPrefid);
    this.props.cancel();    
  }

  getContinueButtonId = () => {
    return this.props.continueButtonId
      ? this.props.continueButtonId
      : "continue-btn";
  };

  getCancelButtonId = () => {
    return this.props.cancelButtonId
      ? this.props.cancelButtonId
      : "cancel-btn";
  };

  getContinueButtonLabel = () => {
    return this.props.continueButtonLabel
      ? this.props.continueButtonLabel
      : "Yes, confirm selection";
  };

  getCancelButtonLabel = () => {
    return this.props.cancelButtonLabel
      ? this.props.cancelButtonLabel
      : "No, Cancel";
  };


  render() {
    return (
      <React.Fragment>
        <div className="container">
          <div className={styles.popup}>
            <div className={styles.btnMargins + " row"}>
              <div className="col-sm-12 text-center">
                <button
                  id="cancel-btn"
                  type="button"
                  className={
                    "axa-header-close close span close-text  " + (getLayout() === 'MOL'? styles.crossBtn : styles.crossBtnhol )
                  }
                  aria-label="Cancel"
                  onClick={() => this.props.cancel()}
                >
                  <span aria-hidden="true" className={styles.closebtn}>×</span>
                </button>
              </div>
            </div>
            <div className={styles.btnMargin + " row"}>
              <div className={" row"}>
                <div className="col-sm-12 text-center">
                  <p>
                    <h4>{this.props.heading}</h4> </p>
                </div>

                <div className="col-sm-12 text-center">
                  <p>
                    {this.props.description}<br></br>
                    <strong>{this.props.CommConfirmation}</strong>
                  </p>
                  <p></p>
                  <div>

                  </div>
                </div>
                <div className="col-sm-12 text-center">
                  <Button
                    label={this.getContinueButtonLabel()}
                    onClick={e => this.onChange(e)}
                    buttonType="primaryBlueButton"
                    key={this.getContinueButtonLabel()}
                    id={this.getContinueButtonId()}
                    disabled={!!this.props.isButtonDisabled}
                    btntype="formButton"
                  />
                </div>
                <div className="col-sm-12 text-center">
                  <Button
                    label={this.getCancelButtonLabel()}
                    onClick={(e) => this.onBack(e)}
                    buttonType={getLayout() === Layouts.HOL ? "secondaryOrangeButton" : "secondaryBlueButton"}
                    key={this.getCancelButtonLabel()}
                    id={this.getCancelButtonId()}
                    disabled={!!this.props.isButtonDisabled}
                    btntype="formButton"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ModalPopupNeeds; 
